import { render, staticRenderFns } from "./goodCustomDetail.vue?vue&type=template&id=635ae025"
import script from "./goodCustomDetail.vue?vue&type=script&lang=js"
export * from "./goodCustomDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports